"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_text_mask_1 = __importDefault(require("react-text-mask"));
const classnames_1 = __importDefault(require("classnames"));
const checkbox_1 = __importDefault(require("components/cosmos/checkbox/checkbox"));
const input_1 = require("components/input");
const translate_1 = require("components/translate");
const constants_1 = require("modules/content/constants");
require("./Dripping.scss");
const LiberationByDay = ({ active, setActive, value, onChange, errors, t }) => {
    const className = (0, classnames_1.default)('dripping__box', {
        active,
        '_border-red': (errors === null || errors === void 0 ? void 0 : errors.length) > 0
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [(0, jsx_runtime_1.jsx)(checkbox_1.default, { onChange: () => setActive(constants_1.LIBERATION_TYPE.BY_DAYS), checked: active, id: "liberation-by-days", label: t('dripping.days.title') }), (0, jsx_runtime_1.jsx)("label", { className: "label__description mb__md", children: t('dripping.days.description_new') }), (0, jsx_runtime_1.jsxs)(input_1.InputBlock, { inline: true, labelValue: "dripping.release_in", children: [(0, jsx_runtime_1.jsx)(react_text_mask_1.default, { guide: false, mask: [/\d/, /\d/, /\d/, /\d/], className: "dripping__days", id: "dripping__days", value: value, onChange: onChange }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "dripping__days", children: t('general.days') }), errors === null || errors === void 0 ? void 0 : errors.map((error) => ((0, jsx_runtime_1.jsx)("p", { className: "error", children: t(error, {
                            data: {
                                min: 0,
                                days: constants_1.MAX_LIBERATION_DAYS,
                                years: constants_1.MAX_LIBERATION_DAYS_IN_YEARS
                            }
                        }) }, error)))] })] }));
};
exports.default = (0, translate_1.translate)()(LiberationByDay);
